import React from "react";

export default function Section({ children, id, className }) {
  return (
    <section id={id} className={className}>
      <div className="container">{children ? children : null}</div>
    </section>
  );
}
